import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const MarketHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontSize: "28px",
      fontWeight: 800,
    },
    cryptoUpdate: {
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: "16px",
      color: theme.palette.text.secondary,
      marginLeft: "8px",
    },
    gains: {
      color: "#01C0AA",
    },
    loses: {
      color: "red",
    },
  }),
);
